import { useMsal } from "@azure/msal-react";
import { PrimaryButton } from "@fluentui/react";
import LogoutButton from "./components/LogoutButton";

const Diagnostics = () => {
  const { instance } = useMsal();

  // check cookie bksession
  const bkSession = document.cookie
    .split(";")
    .find((c) => c.trim().startsWith("bksession="));
  const bkSessionPresent = bkSession ? "yes" : "missing";

  const paragraphStyle = {
    margin: "0em 0",
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        padding: "1em",
        backgroundColor: "lightsalmon",
      }}
    >
      <div>
        <h2>Diagnostics Page</h2>
        <div style={paragraphStyle}>Hello, this is odd :/</div>
        <br />
        <div style={paragraphStyle}>
          It appears that you have been authenticated; however, we were unable to
          establish a session with the backend, or the redirect did not function as
          intended.
        </div>
        <br />
        <div style={paragraphStyle}>
          So please first try to &nbsp;&nbsp;
          <PrimaryButton
            onClick={() => {
              window.location.reload();
            }}
          >
            Reload the Page
          </PrimaryButton>
          &nbsp;&nbsp;or just hit F5.
        </div>
        <br />
        <div style={paragraphStyle}>
          If this doesn&apos;t help, please try to &nbsp;&nbsp;
          <LogoutButton />
          &nbsp;&nbsp; and back in again.
        </div>
        <br />
        <div style={paragraphStyle}>
          In case you still see this page, please contact the page admin.
        </div>
        <br />
        <div style={paragraphStyle}>Auth details:</div>
        <ul>
          <li>
            Entra ID: authenticated as{" "}
            <b>
              <span style={paragraphStyle}>
                {(instance &&
                  instance.getActiveAccount() &&
                  instance.getActiveAccount().username) ||
                  "NOT AUTHENTICATED (should not happend on this page)"}
              </span>
            </b>
          </li>
          <li>
            Session token:{" "}
            <b>
              <span style={paragraphStyle}>{bkSessionPresent}</span>
            </b>
          </li>
        </ul>

        <br />
        {/* <DefaultButton onClick={() => {}}>Create session</DefaultButton> */}
        {/* <CreateSessionAndReload /> */}
      </div>
    </div>
  );
};

export default Diagnostics;
